module.exports = __webpack_public_path__ + "6dae5a749c2edc0d2bd676376ea817c1.svg";